import React, { useEffect, useMemo, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Button } from "flowbite-react";
import axios from "../config/axiosInstance";
import { INTEGRATIONS } from "../config/apiConfig";

const MESSAGE = {
  loading: "Concluindo conexão com o Google...",
  success: "Google Calendar conectado! Você será redirecionado em instantes.",
  error:
    "Não foi possível concluir a conexão. Volte à tela de perfil e tente novamente.",
};

export default function GoogleCalendarCallbackPage() {
  const location = useLocation();
  const navigate = useNavigate();
  const params = useMemo(
    () => new URLSearchParams(location.search),
    [location.search]
  );
  const [status, setStatus] = useState("loading");
  const [details, setDetails] = useState("");

  useEffect(() => {
    const code = params.get("code");
    const errorDescription = params.get("error_description");
    if (errorDescription) {
      setStatus("error");
      setDetails(errorDescription);
      return;
    }
    if (!code) {
      setStatus("error");
      setDetails("Código OAuth ausente.");
      return;
    }

    const redirectUri = `${window.location.origin}${location.pathname}`;

    (async () => {
      try {
        await axios.post(INTEGRATIONS.GOOGLE_CALENDAR_TOKEN, {
          code,
          redirectUri,
        });
        setStatus("success");
        setTimeout(() => {
          navigate("/profile", {
            state: {
              toast: {
                title: "Google Calendar",
                message: "Integração concluída com sucesso!",
              },
            },
          });
        }, 1800);
      } catch (err) {
        setStatus("error");
        setDetails(
          err?.response?.data?.message ||
            err?.message ||
            "Erro desconhecido ao conectar."
        );
      }
    })();
  }, [location.pathname, navigate, params]);

  return (
    <div className="flex items-center justify-center px-4">
      <div className="w-full max-w-lg rounded-2xl border border-slate-800 bg-slate-950/60 p-6 text-center shadow-sm bg-white mt-6">
        <p className="text-sm uppercase tracking-[0.4em] text-orange-500">
          Google Calendar
        </p>
        <h1 className="mt-4 text-2xl font-semibold">{MESSAGE[status]}</h1>
        {details && <p className="mt-3 text-sm text-slate-300">{details}</p>}
        {status === "error" && (
          <div className="mt-6 flex justify-center">
            <Button
              color="light"
              onClick={() => navigate("/profile")}
              className="w-full"
            >
              Voltar ao perfil
            </Button>
          </div>
        )}
      </div>
    </div>
  );
}
